"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutePlanTemplateWithSchedulesQuery = exports.RoutePlanTemplateWithSchedules = exports.RoutePlanTemplateUpdateTransport = exports.RoutePlanTemplateUpdate = exports.RoutePlanTemplateCreate = exports.RoutePlanTemplateQuery = exports.RoutePlanTemplateFullViewTransport = exports.RoutePlanTemplateTransport = exports.RoutePlanTemplate = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const equipment_1 = require("../../equipment");
const DailyRoutePlan_1 = require("../daily-operations/DailyRoutePlan");
const RoutePlanStop_1 = require("../daily-operations/RoutePlanStop");
const enums_1 = require("../enums");
const RoutePlanTemplateStop_1 = require("./RoutePlanTemplateStop");
exports.RoutePlanTemplate = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    recurrenceDurationUnit: enums_1.PickupCycleUnit,
    recurrenceDurationValue: typebox_1.Type.Integer(),
    recurrenceDays: typebox_1.Type.Array(typebox_1.Type.Integer()),
    name: typebox_1.Type.String(),
    materials: typebox_1.Type.Array(common_1.Material),
    truckType: equipment_1.TruckType,
    expectedStartTime: typebox_1.Type.String({ format: 'time' }),
    defaultDriverID: typebox_1.Type.String({ format: 'uuid' }),
    startingYardID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid', description: 'External reference to Yard entity from `hauler` service.' })),
    supervisorID: typebox_1.Type.Optional(typebox_1.Type.String({
        format: 'uuid',
        description: 'External reference to Profile entity. Leave blank if no fixed assignment.',
    })),
    allowedDumpFacilityIDs: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' }), {
        description: `External reference to DisposalSite entity. If empty, the driver may choose from among any of the hauler's disposal facilities at their discretion.`,
    })),
    stops: typebox_1.Type.Array(RoutePlanTemplateStop_1.RoutePlanTemplateStop),
    metadata: common_1.MetaData,
});
exports.RoutePlanTemplateTransport = exports.RoutePlanTemplate;
exports.RoutePlanTemplateFullViewTransport = typebox_1.Type.Object({
    routes: typebox_1.Type.Array(exports.RoutePlanTemplate),
    unscheduledStops: typebox_1.Type.Array(RoutePlanTemplateStop_1.RoutePlanTemplateStop),
    orphanStops: typebox_1.Type.Array(RoutePlanStop_1.RoutePlanStop),
});
exports.RoutePlanTemplateQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        templateIDs: typebox_1.Type.String(), // comma separated list of RoutePlanTemplate ids
        haulerID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]));
exports.RoutePlanTemplateCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RoutePlanTemplate, ['id', 'haulerID', 'stops', 'metadata']),
    typebox_1.Type.Object({
        attachStopIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    }),
]);
exports.RoutePlanTemplateUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RoutePlanTemplate, ['id', 'haulerID', 'startingYardID', 'supervisorID', 'metadata']),
    typebox_1.Type.Object({
        noReconciliation: typebox_1.Type.Boolean(),
        attachStopIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
        startingYardID: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' })),
        supervisorID: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' })),
    }),
]));
exports.RoutePlanTemplateUpdateTransport = typebox_1.Type.Intersect([
    exports.RoutePlanTemplateTransport,
    typebox_1.Type.Object({
        scheduleChanges: typebox_1.Type.Object({
            dailyRoutes: typebox_1.Type.Array(DailyRoutePlan_1.DailyRoutePlanTransport),
            unassignedStops: typebox_1.Type.Array(RoutePlanStop_1.RoutePlanStopTransport),
        }),
    }),
]);
exports.RoutePlanTemplateWithSchedules = typebox_1.Type.Intersect([
    exports.RoutePlanTemplateTransport,
    typebox_1.Type.Object({
        dailyRoutes: typebox_1.Type.Array(DailyRoutePlan_1.DailyRoutePlanTransport),
    }),
]);
exports.RoutePlanTemplateWithSchedulesQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        templateIDs: typebox_1.Type.String(), // comma separated list of RoutePlanTemplate ids
        fromDate: typebox_1.Type.String({ format: 'date' }),
        toDate: typebox_1.Type.String({ format: 'date' }),
    }),
]));
//# sourceMappingURL=RoutePlanTemplate.js.map